import { Typography } from '@mui/material';
import React from 'react';
import { RichTextView } from '../../components/RichText';

interface AnalysisSummaryProps {
  body: string;
  heading: string;
}
const AnalysisSummary = (props: AnalysisSummaryProps) => {
  return (
    <section>
      <Typography
        sx={{
          fontSize: '18px',
          color: 'text.primary',
          fontWeight: 550
        }}
      >
        {props.heading}
      </Typography>
      <RichTextView value={props.body} muiStyling={{ fontSize: '18px', color: 'text.primary', mb: 1 }} />
    </section>
  );
};

export default AnalysisSummary;
